import { ADD_PEOPLE_MULTIPLE, ADD_PEOPLE_SINGLE, VIEW_PEOPLE } from "../../../routes/routeConfig";
export default (function () { return [
    {
        to: VIEW_PEOPLE,
        label: "admin.components.usersNav.view"
    },
    {
        to: ADD_PEOPLE_SINGLE,
        label: "admin.components.usersNav.addSingle"
    },
    {
        to: ADD_PEOPLE_MULTIPLE,
        label: "admin.components.usersNav.addMultiple"
    }
]; });
